export default __webpack_public_path__ + "static/media/controlled_input.6327dad1.jpg";